module.exports = __webpack_public_path__ + "media/images/manage_roles_inactive-92cbf9a754853f3f8ab212f0166b4538.png";